<template>
  <div v-loading="load">
    <el-row class="paddingTop paddingContainer" v-loading="load">
      <el-col :xs="24" :sm="12" :md="5" :lg="5">
        <el-form class="form-map-main">
          <el-form-item label="FILTRO POR PATENTE">
            <el-input
              v-model="search"
              size="mini"
              placeholder="Patente">
              <template slot="append">{{vehicles.filter(
                data => !search ||
                data.patent.toLowerCase().includes(
                  search.toLowerCase())).length}}</template>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="delayedTrucksTable roundedBorder">
      <el-table
        :data="vehicles.filter(
        data => !search || data.patent.toLowerCase().includes(search.toLowerCase()))"
        height="100%"
        size="mini"
        width="100%">
        <el-table-column label="#" type="index" align="center">
        </el-table-column>
        <el-table-column
          label="PATENTE"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            {{scope.row.patent}}
          </template>
        </el-table-column>
        <el-table-column
          label="REVISIÓN TÉCNICA"
          min-width="130"
          align="center">
          <template slot-scope="scope">
            {{scope.row.technical_review | momentDate}}
          </template>
        </el-table-column>
        <el-table-column
          label="SEGURO OBLIGATORIO"
          min-width="155"
          align="center">
          <template slot-scope="scope">
            {{scope.row.obligatory_insurance | momentDate}}
          </template>
        </el-table-column>
        <el-table-column
          label="SEGURO"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            {{scope.row.insurance | momentDate}}
          </template>
        </el-table-column>
        <el-table-column
          label="CERTIFICADO"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            {{scope.row.certificate | momentDate}}
          </template>
        </el-table-column>
        <el-table-column
          label="TIPO"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            {{scope.row.vehicle_type.name}}
          </template>
        </el-table-column>
        <el-table-column
          label="TELÉFONO"
          min-width="120"
          align="center">
          <template slot-scope="scope">
            {{scope.row.phone}}
          </template>
        </el-table-column>
        <el-table-column label="ACTIVAR"
                         align="center"
                         min-width="75"
                         prop="active" >
          <template      slot-scope="scope"
                         align="center">
            <el-switch v-model="scope.row.active"
                       @change="changeActivate(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { apiRequest } from '../../backend/vue-axios/axios';

export default {
  name: 'TracingEnterpriseVehicles',
  props: {
    enterprise: {
      type: Number,
    },
  },
  data() {
    return {
      load: false,
      tagType: 'info',
      totalVehicles: 0,
      vehicles: [],
      search: '',
    };
  },
  methods: {
    changeActivate(row) {
      const text = ((row.active) ? 'habilitar' : 'deshabilitar');
      this.$confirm(`¿Seguro que desea ${text} el vehículo de patente ${row.patent} ?.`, 'Cuidado', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(() => {
        apiRequest({
          module: 'tracing',
          service: 'toggle_vehicle',
          params: {
            vehicle_id: row.id,
            toggle: row.active,
          },
        }).then((res) => {
          const textNotify = ((row.active) ? 'habilitado' : 'deshabilitado');
          this.$notify({
            type: 'success',
            title: `El vehículo ${row.patent} fue ${textNotify}`,
            message: res.data.message, // TODO No envia mensaje al activar la ruta.
          });
        }).catch((error) => {
          const selectedVehicle = this.vehicles.filter(vehicle => vehicle.id === row.id);
          selectedVehicle[0].active = !row.active;
          if (error.response) {
            this.$notify({
              type: 'error',
              title: 'Error',
              message: error.response.data.message,
            });
          }
        });
      }).catch(() => {
        const selectedVehicle = this.vehicles.filter(vehicle => vehicle.id === row.id);
        selectedVehicle[0].active = !row.active;
      });
    },
    setDrivers() {
      this.load = true;
      apiRequest({
        module: 'tracing',
        service: 'vehicles',
        params: {
          limit: 1000,
        },
      }).then((result) => {
        this.vehicles.pop();
        this.vehicles = result.data;
        this.totalVehicles = this.vehicles.length;
        this.load = false;
      }).catch(() => {
        this.load = false;
        this.$notify.error({
          title: 'Error',
          message: 'Error al obtener información',
        });
      });
    },
  },
  filters: {
    momentDate(time) {
      if (time) {
        const date = moment.utc(time).format('DD-MM-YYYY');
        return date;
      }
      return '';
    },
  },
  created() {
    this.setDrivers();
  },
  watch: {
    enterprise() {
      this.setDrivers();
    },
  },
};
</script>

<style scoped>
  .topTitle {
    font-size: 14px;
    text-align: left;
    margin: 0 0 5px;
  }

  .roundedBorder {
    box-sizing: border-box;
    border-radius: 3px;
    background: white;
    height: 62vh;
  }
  @media only screen and (min-width: 768px) {
    .topTitle {
      margin-top: 1.7em;
    }
  }
</style>
